module.exports = __webpack_public_path__ + "img/services-shape2.f5bf7d42.png";